<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <a-textarea
      :size="size"
      :rows="varRows"
      v-decorator="[varName, { 
                    rules: [{ required: varRequired, message: message}],
                    initialValue: varInitial
                    }]"
      :placeholder="varLabel"
    />
    <a-alert :message="description" type="info" showIcon style="margin-top:5px;" v-if="description" />
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: String,
    varRequired: Boolean,
    formLayout: String,
    size: String,
    description: [String, null],
    varRows: {
      type: Number,
      default: 2
    }
  },
  computed: {
    message() {
      return `Please enter ${this.varLabel.toLowerCase()}`;
    }
  }
};
</script>
